import { Routes } from '@angular/router';
import { CompanyPolicy } from './pages/company-policy/company-policy';
import { ContactUs } from './pages/contact-us/contact-us';
import { Faq } from './pages/faq/faq';
import { Home } from './pages/home/home';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'contact-us', component: ContactUs },
  { path: 'faq', component: Faq },
  { path: 'privacy-policy', component: PrivacyPolicy },
  { path: 'company-policy', component: CompanyPolicy },
  { path: '**', redirectTo: '' },
];
